/**
 * Sayac fiziksel olculeri (cm cinsinden)
 * Kaynak: docs/sayac3F.png, docs/sayac1F.png - uretici datasheet olculeri
 *
 * 3F: 140.90mm x 163.50mm  (ust 35mm hook, orta 92.20mm govde, alt ~36.30mm terminal)
 * 1F: 94.50mm x 137.30mm   (ust 25mm hook, orta 70mm govde, alt ~42.30mm terminal)
 */

export const METER_PHYSICAL = {
  3: {
    width: 14.09,           // 140.90mm
    height: 16.35,          // 163.50mm
    hookAreaH: 3.5,         // 35mm - ust montaj/kanca bolgesi
    displayAreaH: 9.22,     // 92.20mm - ekran/govde yuzeyi
    terminalAreaH: 3.63,    // 36.30mm - alt terminal blogu
    hookSpacing: 10.0,      // 50mm + 50mm - kanca merkezler arasi
    terminalCount: 8,       // terminal sayisi
  },
  1: {
    width: 9.45,            // 94.50mm
    height: 13.73,          // 137.30mm
    hookAreaH: 2.5,         // 25mm - ust montaj/kanca bolgesi
    displayAreaH: 7.0,      // 70mm - ekran/govde yuzeyi
    terminalAreaH: 4.23,    // 42.30mm - alt terminal blogu
    hookSpacing: 7.0,       // 35mm + 35mm - kanca merkezler arasi
    terminalCount: 4,       // terminal sayisi
  },
};

/**
 * Faz sayisina gore fiziksel olculeri dondur
 * @param {number} phase - 1 veya 3
 * @returns {object} Fiziksel olculer
 */
export function getMeterPhysical(phase) {
  return METER_PHYSICAL[phase] || METER_PHYSICAL[3];
}
